<script setup>
import { useBorrowerStore } from '~/store/borrower'

definePageMeta({
  middleware: [
    async function(to, from) {
      const nuxtApp = useNuxtApp()
      const { $pinia } = nuxtApp
      const borrowerStore = useBorrowerStore($pinia)

      const redirectUrl = borrowerStore.borrowerValues?.marketplaceAppCompleted?.value
        ? '/next-steps/what-comes-next'
        : '/next-steps/funding-expert'
      return nuxtApp.runWithContext(() => navigateTo(redirectUrl, { replace: true }))
    }
  ],
})
</script>
